import { createSlice } from '../zustandHelpers'
import { toastError } from '../../../infrastructure/hooks/useToast'
import { IDocumentsActions, IDocumentsState } from './documents.slice.interface'

export const documentsSlice = createSlice<IDocumentsState, IDocumentsActions>((set) => ({
  documents: null,
  documentsLoading: false,
  documentsError: null,
  multipleDownloadLoading: false,

  // Action to fetch documents
  setDocumentsLoading: async () => {
    set((state) => ({
      documentsLoading: !state.documentsLoading,
    }))
  },

  // Action to set documents
  setDocuments: async (documents) => {
    set(() => ({
      documentsLoading: false,
      documents: documents.map((doc) => ({ ...doc, loading: false })),
    }))
  },

  // Action to fetch a document's blob
  setBlobFetching: async (id: string) => {
    set((state) => ({
      documentsError: null,
      documents:
        state.documents?.map((doc) =>
          doc.sharepointId === id ? { ...doc, loading: !doc.loading } : doc
        ) || [],
    }))
  },

  // Action to download a single file
  setSingleFileDownloading: async (id: string) => {
    set((state) => ({
      documentsError: null,
      documents:
        state.documents?.map((doc) =>
          doc.sharepointId === id ? { ...doc, loading: !doc.loading } : doc
        ) || [],
    }))
  },

  // Action to download multiple files
  setMultipleFilesDownloadLoading: async () => {
    set({ multipleDownloadLoading: false })
  },

  resetDocuments: () => {
    set({
      documents: null,
      documentsLoading: false,
      documentsError: null,
      multipleDownloadLoading: false,
    })
  },

  // Set loading state
  setLoading: () => {
    set({ documentsLoading: true })
  },

  // Set error state
  setError: (error: string) => {
    set((state) => ({
      documentsError: [...(state.documentsError || []), error],
    }))
    toastError(error)
  },

  // Clear error state
  clearError: () => {
    set({ documentsError: null })
  },
}))
